/* unplugin-vue-components disabled */import script from "./mainHeader.vue?vue&type=script&lang=js"
export * from "./mainHeader.vue?vue&type=script&lang=js"

import "./mainHeader.vue?vue&type=style&index=0&id=147a41e4&lang=scss"

const __exports__ = script;

export default __exports__